import constants from '@/constant'

const isTreatmentShareV2 = (state) => {
  return state.currentUser.abTest &&
    state.currentUser.abTest[constants.AB_TEST.SHARE_V2] === constants.AB_VARIANT.TREATMENT
}

export default {
  isTreatmentShareV2,
}
